import { useEffect, useState } from 'react';
import './SinisterForm.css';
import PropTypes from 'prop-types';
import { Input, Label, Select } from 'atm-global-stylish/dist';
import { provinciasArgentinas, paisesSudamericanos, localidadesPorProvincia } from '../../utils/dataForm';
import { isEmpty } from '../../utils/functions';
import { INPUT_CLASSNAME, SELECT_CLASSNAME } from '../../config/constants';

const SinisterForm = ({ errors, sinisterData, handleChange }) => {
	const defaultListLocalidades = [{ title: 'LOCALIDAD *', value: '' }];

	const [localidades, setLocalidades] = useState(defaultListLocalidades);
	const [provincia, setProvincia] = useState('');
	const [localidad, setLocalidad] = useState('');

	useEffect(() => {
		if (!isEmpty(sinisterData.sinister_province)) {
			if (!isEmpty(provincia) && provincia !== sinisterData.sinister_province) {
				handleChange('sinister_location')({ target: { value: '' } });
				setLocalidad('');
			}

			setProvincia(sinisterData.sinister_province);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sinisterData.sinister_province]);

	useEffect(() => {
		// comprueba que la localidad sea empty ya que la única vez que toma valor es cuando el array de localidades se llena con la provincia
		if (!isEmpty(provincia) && isEmpty(localidad)) {
			fetchLocalidades(provincia);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [provincia, localidad]);

	useEffect(() => {
		if (localidades.length > 1 && !isEmpty(sinisterData.sinister_location)) {
			setLocalidad(sinisterData.sinister_location);
		}
	}, [sinisterData.sinister_location, localidades]);

	const fetchLocalidades = (value) => {
		const provincia = localidadesPorProvincia.find(p => p.nombre.toLowerCase() === value.toLowerCase());

		if (!isEmpty(provincia.localidades)) {
			const aux = defaultListLocalidades;
			provincia.localidades.forEach((v, i) => {
				aux.push({
					title: v,
					value: v
				});
			});
			setLocalidades(aux);
		}
	}

	return (
		<div className='flex w-full m-auto flex-col justify-center items-center gap-2'>
			<div className='w-full flex flex-col gap-5 md:gap-5 my-4'>
				<div className='grid grid-cols-1 md:grid-cols-2 w-full justify-between md:gap-10'>
					<Input type='text' value={sinisterData.sinister_address} handleChange={handleChange('sinister_address')} className={`${!errors.sinister_address ? 'input' : 'incomplete'} mb-5 md:mb-0 ${INPUT_CLASSNAME}`} placeholder='DIRECCIÓN DE OCURRENCIA DEL SINIESTRO *' maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
					<div className="flex flex-row gap-0">
						<label htmlFor='sinister_time' className={`text-nowrap content-center font-semibold text-sm ${!errors.sinister_time ? 'text-grey-tx' : 'text-shiny-pink'} border-b-2 border-shiny-pink pt-1 ps-4 border-l-2 border-l-white`}>HORA DE OCURRENCIA *</label>
						<Input name='sinister_time' type='time' value={sinisterData.sinister_time} handleChange={handleChange('sinister_time')} className={`${!errors.sinister_time ? 'input' : 'incomplete'} ${INPUT_CLASSNAME} !border-l-0`} />
					</div>
				</div>
				<div className='flex flex-col md:flex-row w-full justify-between md:gap-10'>
					<div className="w-full mb-5 md:mb-0">
						<Select
							list={provinciasArgentinas}
							onChange={handleChange('sinister_province')}
							selectedValue={String(provincia)}
							className={`${errors.sinister_province ? 'text-shiny-pink' : 'text-grey-tx'} ${SELECT_CLASSNAME}`}
							dataSearch
							inputSearchHidden={false}
						/>
					</div>
					<Select
						list={localidades}
						onChange={handleChange('sinister_location')}
						selectedValue={String(localidad)}
						className={`${errors.sinister_location ? 'text-shiny-pink' : 'text-grey-tx'} ${SELECT_CLASSNAME}`}
						dataSearch
						inputSearchHidden={false}
					/>
				</div>
				<div className='flex flex-row w-full justify-between md:gap-10'>
					<Select
						list={paisesSudamericanos}
						onChange={handleChange('sinister_country')}
						selectedValue={String(sinisterData.sinister_country)}
						className={`${errors.sinister_country ? 'text-shiny-pink' : 'text-grey-tx'} ${SELECT_CLASSNAME}`}
					/>
				</div>
				<div className='flex w-full'>
					<textarea
						className={`border-2 border-pink rounded-lg p-3 w-full h-40 resize-none ${INPUT_CLASSNAME} focus:outline-none ${!errors.sinister_detail ? 'input' : 'incomplete'}`}
						placeholder="CONTANOS CÓMO OCURRIÓ EL SINIESTRO *"
						onChange={handleChange('sinister_detail')}
						value={sinisterData.sinister_detail}
						maxLength={200}
					/>
				</div>
			</div>
		</div>
	);
};

SinisterForm.propTypes = {
	errors: PropTypes.object.isRequired,
	sinisterData: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default SinisterForm;